import React, { useContext, useEffect } from 'react';

import { isSSR } from 'Utilities/helpers';
import { useQuery } from 'Utilities/hooks';
import { safeLocalStorage } from 'Utilities/storages';

import {
  DOCUMENT_CAPTURE_AUTOMATED_REVIEW_KEY,
  DOCUMENT_CAPTURE_REVIEW_KEY,
  INCODE_QUERY_PARAM,
} from '../DocumentCapture.helpers';
import { DocumentCaptureOfferContext } from '../DocumentCaptureContexts';
import { DocumentCaptureViewContainer } from '../shared/DocumentCaptureViewContainer/DocumentCaptureViewContainer';

import { ReviewStatusIncodeView } from './ReviewStatusIncodeView';
import { ReviewStatusSubview } from './ReviewStatusSubview';

export const ReviewStatusView = () => {
  const { acceptedBid, enquiryId } = useContext(DocumentCaptureOfferContext) || {};

  // First entry to view the automated review page has to be done via query string (sent from Incode)
  // We then set the local storage to remember that the user has viewed the page to allow them to return
  // to the page without needing to go through the query string again
  const incodeParam = useQuery(INCODE_QUERY_PARAM);
  const isAutomatedReview = !isSSR() ? (safeLocalStorage.getItem(DOCUMENT_CAPTURE_AUTOMATED_REVIEW_KEY) || []) : [];
  const showAutomatedReviewPage = incodeParam || isAutomatedReview.includes(String(enquiryId));

  useEffect(() => {
    const automatedReviewVehicles = safeLocalStorage.getItem(DOCUMENT_CAPTURE_AUTOMATED_REVIEW_KEY) || [];
    const currentEnquiryId = String(enquiryId);

    if (automatedReviewVehicles.includes(currentEnquiryId) || !enquiryId) {
      return;
    }

    automatedReviewVehicles.push(currentEnquiryId);

    if (incodeParam) {
      safeLocalStorage.setItem(DOCUMENT_CAPTURE_AUTOMATED_REVIEW_KEY, automatedReviewVehicles);
    }
  }, [enquiryId, incodeParam]);

  useEffect(() => {
    const reviewVehicles = safeLocalStorage.getItem(DOCUMENT_CAPTURE_REVIEW_KEY) || [];
    const currentEnquiryId = String(enquiryId);

    if (reviewVehicles.includes(currentEnquiryId) || !enquiryId) {
      return;
    }

    reviewVehicles.push(currentEnquiryId);
    safeLocalStorage.setItem(DOCUMENT_CAPTURE_REVIEW_KEY, reviewVehicles);
  }, [enquiryId]);

  // If the seller is on the automated review page, we want to show the automated review status
  if (showAutomatedReviewPage) {
    return <ReviewStatusIncodeView />;
  }

  return (
    <DocumentCaptureViewContainer>
      <ReviewStatusSubview acceptedBidDealerName={acceptedBid?.dealer?.name} />
    </DocumentCaptureViewContainer>
  );
};
